module.exports = __webpack_public_path__ + "img/logo.cd5f8aa.svg";